import { Link } from 'react-router-dom';

function Category(props) {
  return (
    <div className="detail__category-container">
      <div className="detail__category-wrapper">
        <Link to="/">
          <span>홈</span>
        </Link>
        /
        {props.state.name ? (
          <Link to={`/products/${props.state.section}/${props.state.path}`}>
            <span>{props.state.name}</span>
          </Link>
        ) : (
          <Link to={`/products`}>
            <span>제품보기</span>
          </Link>
        )}
        /<span>{props.name}</span>
      </div>
    </div>
  );
}

export default Category;
